export const useProductComponentsStore = defineStore('productComponents', {
  state: () => ({
    productComponents: null as PaginatedProductComponent | null,
  }),
  getters: {
    getProductComponents: (state) =>
      state.productComponents !== null ? state.productComponents.items : [],
  },
  actions: {
    setProductComponents(productComponents: PaginatedProductComponent) {
      useLocalStorage().setItem('productComponents', productComponents);
      this.productComponents = productComponents;
    },
    async createProductComponent(
      productComponent: ProductComponentCreateUpdate,
    ): Promise<ProductComponent | undefined> {
      try {
        const {data} = await apiPostProductComponent(productComponent);
        pushDataToPaginatedState(this.productComponents, data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductComponents({
      offset,
      limit,
      search,
    }: {offset?: number; limit?: number; search?: string} = {}): Promise<
      PaginatedProductComponent | undefined
    > {
      // Parse the local storage value & set the state.
      const localStorageProductComponents: PaginatedProductComponent | null =
        useLocalStorage().getItem('productComponents');
      if (localStorageProductComponents) {
        this.setProductComponents(localStorageProductComponents);
      }
      try {
        const {data} = await apiGetProductComponents(limit, offset, search);
        this.setProductComponents(data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductComponentById(id: string | number): Promise<ProductComponent | undefined> {
      // Parse & return the local storage value.
      const localStorageProductComponents: PaginatedProductComponent | null =
        useLocalStorage().getItem('productComponents');
      if (localStorageProductComponents) {
        const foundProductComponent = localStorageProductComponents.items.find((p) => p.id === id);
        if (foundProductComponent !== undefined) return foundProductComponent;
      }
      try {
        const {data} = await apiGetProductComponent(id);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async updateProductComponent(
      productComponent: ProductComponentCreateUpdate,
    ): Promise<ProductComponent | undefined> {
      try {
        const response = await apiPutProductComponent(productComponent);
        const data: ProductComponent = response.data;
        // Find & update the target object.
        if (this.productComponents !== null) {
          const index = this.productComponents.items.findIndex((p) => p.id === data.id);
          if (index >= 0) {
            Object.assign(this.productComponents.items[index], data);
            useLocalStorage().setItem('productComponents', this.productComponents);
          }
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteProductComponent(id: string | number) {
      try {
        await apiDeleteProductComponent(id);
        // Find & remove the element.
        if (this.productComponents !== null) {
          const index = this.productComponents.items.findIndex((p) => p.id === id);
          if (index >= 0) {
            this.productComponents.items.splice(index, 1);
            useLocalStorage().setItem('productComponents', this.productComponents);
          }
          this.productComponents.total -= 1;
        }
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
  },
});
